import HomeTitleText from "../../texts/homeScreen/HomeTitleText";
import HomeSubtitleText from "../../texts/homeScreen/HomeSubtitleText";
import {kHomeTexts} from "../../../constants/texts";
import {SystemPrimaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import {internalRoutes} from "../../../constants/internalRoutes";

export default function HomeShowCase() {
    // Used in LadingScreen to display master content
    // in desktop/tablet mode

    // BUILD
    return (
        <div className={"bg-backgroundLight1 w-full min-h-[672px] flex flex-col justify-center items-center"}>
            <div className={"w-[560px] md:w-[708px] grow flex flex-col space-y-[48px] md:space-y-[56px] justify-center pb-[40px]"}>
                <div className={"w-full flex flex-col space-y-[16px] md:space-y-[24px]"}>
                    <HomeTitleText />
                    <HomeSubtitleText />
                </div>
                <div className={"flex justify-center"}>
                    <SystemPrimaryCustomButton
                        label={kHomeTexts.callToActionLabel}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={false}
                        sizeStyle={kButtonStyles.largeButtonStyle}
                        internalLink={internalRoutes.courses}
                        extraClass={"text-[18px]"} />
                </div>
            </div>
        </div>
    );
}